import {useMutation, useQueryClient} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {paymentsApi} from '../api';
import {paymentKeys} from './usePaymentsQuery';

export interface SetPaymentInstructionHandledVariables {
  paymentId: string;
  handled: boolean;
}

export function useSetPaymentInstructionHandledMutation(trustAccountId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({paymentId, handled}: SetPaymentInstructionHandledVariables) =>
      paymentsApi
        .setPaymentInstructionHandled(client, trustAccountId, paymentId, handled)
        .then(res => res.data),
    // On failure too (a 409 means the cached row is stale); returned so the caller's per-row guard outlasts the refetch.
    onSettled: () => queryClient.invalidateQueries({queryKey: paymentKeys.all(trustAccountId)})
  });
}
